const common = {
  // Navbar
  'nav.home': 'Homes',
  'nav.services': 'Services',
  'nav.howItWorks': 'How it works',
  'nav.returns': 'Returns',
  'nav.honestFAQ': 'Honest FAQ',
  'nav.properties': 'Properties',
  'nav.coOwnership': 'Co-ownership',
  'nav.regions': 'Regions',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.requestList': 'Request a property list',
  'nav.langJa': '日本語',
  'nav.langEn': 'EN',

  // Footer
  'footer.description': 'Japanese property, purchased, renovated, and operated for overseas buyers. End to end. In English. No flying required.',
  'footer.navigate': 'Navigate',
  'footer.contact': 'Contact',
  'footer.office': 'Office',
  'footer.nagano': 'Nagano City, Nagano Prefecture',
  'footer.japan': 'Japan',
  'footer.email': 'Email',
  'footer.hours': 'Hours',
  'footer.weekdays': 'Monday – Friday',
  'footer.disclaimerTitle': 'Disclaimer:',
  'footer.disclaimerText': 'Projected yields are illustrative and based on conservative modelling for a representative property; actual returns depend on location, renovation scope, licensing path, and market conditions. Each property is individually modelled before purchase. Ownership of Japanese real estate does not confer residency or visa rights. Foreign buyers must comply with FEFTA reporting and all applicable 2026 disclosure requirements. NOREN K.K. is a licensed real estate broker in Japan.',
  'footer.copyright': '© {{year}} NOREN K.K. All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',

  // Shared / Buttons
  'btn.viewDetails': 'View details',
  'btn.requestList': 'Browse homes',
  'btn.seeWhatWeDo': 'See what we do',
  'btn.submit': 'Submit Inquiry',
  'btn.explore': 'Explore co-ownership listings',
  'btn.getInTouch': 'Get in touch',
  'btn.clearFilters': 'Clear filters',
  'btn.close': 'Close',
  'btn.whatsapp': 'WhatsApp',
  'btn.requestFullDetails': 'Request full details',
  'btn.bookCall': 'Book a 30-min call',
  'btn.openCoListing': 'Open a co-ownership listing',
  'btn.expressInterest': 'Express interest',
  'btn.submitListingRequest': 'Submit listing request',
  'btn.registerInterest': 'Register interest',
  'btn.showAll': 'Show all',
  'btn.backToProperties': 'Back to properties',

  // Shared labels
  'label.offMarket': 'For sale',
  'label.representative': 'Representative image',
  'label.price': 'Price',
  'label.type': 'Type',
  'label.location': 'Location',
  'label.region': 'Region',
  'label.yearBuilt': 'Year built',
  'label.area': 'Area',
  'label.bedrooms': '{{count}} BR',
  'label.units': '{{count}} units',
  'label.searchPlaceholder': 'Search by ID, region, or keyword...',
  'label.sort': 'Sort',
  'label.filters': 'Filters',
  'label.showing': 'Showing {{count}} of {{total}} properties',
  'label.noMatch': 'No properties match your filters.',
  'label.required': 'Required',
  'label.invalidEmail': 'Invalid email',
  'label.maxChars': 'Maximum 500 characters',
  'label.approx': '≈',
  'label.allIn': 'all-in',
  'label.perShare': 'per share',
  'label.spotsLeft_one': '{{count}} spot left',
  'label.spotsLeft_other': '{{count}} spots left',
  'label.full': 'Full',
  'label.cg': 'After · renovation CG',
  'label.current': 'Now · current condition',
  'label.cgShort': 'After',
  'label.currentShort': 'Now',
  'label.of': '{{current}}/{{total}}',

  // Form options
  'option.select': 'Select...',
  'option.us': 'United States',
  'option.uk': 'United Kingdom',
  'option.ca': 'Canada',
  'option.au': 'Australia',
  'option.sg': 'Singapore',
  'option.hk': 'Hong Kong',
  'option.other': 'Other',
  'option.under1m': 'Under ¥1M',
  'option.1mTo5m': '¥1M – ¥5M',
  'option.5mTo10m': '¥5M – ¥10M',
  'option.10mTo30m': '¥10M – ¥30M',
  'option.over20m': 'Over ¥20M',
  'option.rentalIncome': 'Rental income / yield',
  'option.personalUse': 'Personal use + occasional rental',
  'option.retirement': 'Retirement / second home',
  'option.portfolio': 'Portfolio diversification',
  'option.exploring': 'Just exploring',
  'option.liveIn': 'Live in it',
  'option.renovation': 'Renovation project',
  'option.rental': 'Rental income',
  'option.notSure': 'Not sure',

  // Currency
  'currency.yen': '¥',
  'currency.usd': '$',

  // Property types
  'type.all': 'All',
  'type.kominka': 'Kominka',
  'type.detached': 'Detached Houses',
  'type.apartmentBlocks': 'Apartment Blocks',
  'type.condos': 'Condos',

  // Sort options
  'sort.priceAsc': 'Price: Low to High',
  'sort.priceDesc': 'Price: High to Low',
  'sort.yearDesc': 'Year: Newest first',
  'sort.yearAsc': 'Year: Oldest first',

  // WhatsApp
  'whatsapp.prefill': 'Hello NOREN, I\'m interested in property {{id}} ({{headline}}). Could you send me the full details?',
  'whatsapp.btn': 'WhatsApp',

  // Co-ownership modal
  'co.modal.openTitle': 'Open a co-ownership listing',
  'co.modal.interestTitle': 'Express interest: {{title}}',
  'co.modal.subtitle': 'NOREN is a matching board and property agent only. We do not pool money, run investments, or guarantee returns.',
  'co.modal.guardrailTitle': 'Legal guardrail',
  'co.modal.guardrailText': 'Co-owners buy in their own names on title (持分), set all terms in their own written agreement with their own lawyers/tax advisors, and bear all risk and disputes. NOREN\'s role is limited to property brokering and introducing potential co-owners.',
  'co.modal.name': 'Full name',
  'co.modal.email': 'Email',
  'co.modal.country': 'Country of residence',
  'co.modal.coOwnerCount': 'Co-owner count',
  'co.modal.estimatedAllIn': 'Estimated all-in (¥)',
  'co.modal.shareCalc': 'Approx. share per co-owner:',
  'co.modal.shareCalcNote': '{{allIn}} ÷ {{count}} = {{share}}. This is indicative only.',
  'co.modal.notes': 'Notes / preferred structure',
  'co.modal.sharePreference': 'Share preference',
  'co.modal.shareFull': 'Full share',
  'co.modal.shareHalf': 'Half share',
  'co.modal.shareQuarter': 'Quarter share',
  'co.modal.shareFlexible': 'Flexible',
  'co.modal.message': 'Message',
  'co.modal.agreementText': 'I understand that NOREN does not pool money, run investments, or guarantee returns. Co-owners bear all risk and must obtain their own legal and tax advice.',
  'co.modal.agreementError': 'You must agree to continue',
  'co.modal.successOpen': 'Listing request received',
  'co.modal.successInterest': 'Interest registered',
  'co.modal.successText': 'We will review your details and contact you within 2 business days. No money is collected at this stage.',
  'co.modal.nameError': 'Name is required',
  'co.modal.emailError': 'Email is required',
  'co.modal.emailInvalid': 'Invalid email',
  'co.modal.countryError': 'Country is required',
  'co.modal.allInError': 'Estimated all-in is required',
  'co.modal.countError': 'Must be 2–5 co-owners',
  'co.modal.preferenceError': 'Share preference is required',

  // Misc shared
  'misc.thankYou': 'Thank you',
  'misc.responseTime': 'We will send a curated shortlist with honest all-in numbers within 2 business days.',
  'misc.receivedInquiry': 'We have received your inquiry. You will hear back from us within 48 hours with a curated shortlist and next steps.',
};

export default common;